import { useCallback, useEffect, useMemo, useState } from "react";

import { ChatMessageWithParts } from "src/views/assistant/types";
import { DPO_FEEDBACK_TYPE } from "src/constants";

const useMessageGroups = (messageGroup: ChatMessageWithParts[]) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const isMultipleMessages = messageGroup.length > 1;
  const hasPreferredMessage = messageGroup.some(
    (msg) => msg?.feedback_value === 1,
  );
  const groupContainsDpo = messageGroup.some(
    (msg) => msg.ranking_type === DPO_FEEDBACK_TYPE,
  );
  const isAssistantGroup = messageGroup.every(
    (msg) => msg.type === "Assistant",
  );
  const isPreferredMessagePicked = isMultipleMessages && hasPreferredMessage;
  const isFeedbackTypeDpo = messageGroup.every(
    (msg) => msg.ranking_type === DPO_FEEDBACK_TYPE,
  );

  const sortedMessageGroup = useMemo(() => {
    return messageGroup.toSorted((a, b) => {
      const feedbackA = a.feedback_value ?? 0;
      const feedbackB = b.feedback_value ?? 0;
      return feedbackB - feedbackA;
    });
  }, [messageGroup]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [sortedMessageGroup]);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  }, []);

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) =>
      Math.min(prev + 1, sortedMessageGroup.length - 1),
    );
  }, [sortedMessageGroup.length]);

  return {
    sortedMessageGroup,
    currentIndex,
    isMultipleMessages,
    hasPreferredMessage,
    groupContainsDpo,
    isAssistantGroup,
    isPreferredMessagePicked,
    isFeedbackTypeDpo,
    handlePrev,
    handleNext,
  };
};

export default useMessageGroups;
